/**
 * Component session to manage component data module sessions.
 * Contains a reference to sitewise data modules
 */
export class SiteWiseComponentSession {
    constructor({ componentId, siteWiseTimeSeriesModule, siteWiseAssetModule, siteWiseAlarmModule, }) {
        this.sessions = [];
        this.componentId = componentId;
        this.siteWiseTimeSeriesModule = siteWiseTimeSeriesModule;
        this.siteWiseAssetModule = siteWiseAssetModule;
        this.siteWiseAlarmModule = siteWiseAlarmModule;
    }
    attachDataModuleSession(session) {
        this.sessions.push(session);
    }
    close() {
        this.sessions.forEach((session) => session.close());
    }
}
